import React, { Component, Fragment } from "react";
import queryString from "query-string";
import Sidebar from "react-sidebar";
import ActivityList from "./list";
import ActivityFilters from "./filter";
import "../../assets/scss/pages/app-library.scss";

const mql = window.matchMedia(`(min-width: 992px)`)
import { inject, observer } from 'mobx-react';

class ActivityApp extends Component {
  state = {
    sidebarDocked: mql.matches,
    sidebarOpen: false
  }
  UNSAFE_componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged)
  }

  onSetSidebarOpen = open => {
    this.setState({ sidebarOpen: open })
  }

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
  }
  render() {
    return (
      <React.Fragment>
        <div className="_library-application">
          <div
            className={`library-content-overlay ${
              this.state.sidebarOpen ? "show" : ""
              }`}
            onClick={() => this.onSetSidebarOpen(false)}></div>
          <div className="sidebar-section">
            <Sidebar
              sidebar={<ActivityFilters />}
              docked={this.state.sidebarDocked}
              open={this.state.sidebarOpen}
              sidebarClassName="sidebar-library"
              touch={true}
              contentClassName="sidebar-children d-none">
              ""
            </Sidebar>
          </div>
          <ActivityList
            mainSidebar={this.onSetSidebarOpen}
            sidebar={this.state.sidebarOpen}
          />
        </div>
      </React.Fragment>
    )
  }
}


export default ActivityApp;
